import React from 'react';

const ShippingEstimateModal = ({ isOpen, onClose, estimateData }) => {
    if (!isOpen || !estimateData) return null;

    const { from_pincode, to_pincode, weight, zone, partners_pricing } = estimateData.data;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg w-full max-w-3xl relative">
                <button
                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
                    onClick={onClose}
                >
                    ✕
                </button>

                <h2 className="text-xl font-bold text-gray-800 mb-4">Shipping Estimate</h2>

                <div className="mb-4 text-sm text-gray-700">
                    <p><strong>From Pincode:</strong> {from_pincode}</p>
                    <p><strong>To Pincode:</strong> {to_pincode}</p>
                    <p><strong>Zone:</strong> {zone}</p>
                    <p><strong>Weight:</strong> {weight} kg</p>
                </div>

                {/* Partner Pricing Table */}
                <div className="overflow-x-auto">
                    <table className="min-w-full table-auto border-collapse">
                        <thead>
                            <tr className="bg-sky-100 text-gray-700 text-sm">
                                <th className="p-2 border">Partner</th>
                                <th className="p-2 border">Mode</th>
                                <th className="p-2 border">Base Price</th>
                                <th className="p-2 border">Additional Price</th>
                                <th className="p-2 border">COD Price</th>
                                <th className="p-2 border">Total Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(partners_pricing).map(([partner, modes]) => (
                                Object.entries(modes).map(([modeType, pricing], idx) => (
                                    <tr key={`${partner}-${modeType}`} className="text-sm text-center">
                                        {modeType === 'surface' && (
                                            <td rowSpan="2" className="p-2 border font-semibold text-gray-800">
                                                {partner}
                                            </td>
                                        )}
                                        <td className="p-2 border capitalize">{modeType}</td>
                                        <td className="p-2 border capitalize">{pricing.base_price ? `₹ ${pricing.base_price}` : "N/A"}</td>
                                        <td className="p-2 border capitalize">{pricing.additional_price ? `₹ ${pricing.additional_price}` : "N/A"}</td>
                                        <td className="p-2 border capitalize">{pricing.cod_extra ? `₹ ${pricing.cod_extra}` : "N/A"}</td>
                                        <td className="p-2 border capitalize">{pricing.cod_total_price ? `₹ ${pricing.cod_total_price}` : `₹ ${pricing.total_price}`}</td>
                                    </tr>
                                ))
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ShippingEstimateModal;
